module.exports = __webpack_public_path__ + "img/window-mask.1803b7d6.png";